module.exports = __webpack_public_path__ + "media/static/icons/icon-loader-a77e75985347fc42499714832234a590.svg";